import { createFileRoute } from "@tanstack/react-router";
import { AdminLayout } from "@/components/admin/AdminLayout";
import { ProductEditor } from "@/components/admin/products/ProductEditor";

export const Route = createFileRoute("/_authenticated/admin/products/$id")({
  head: () => ({
    meta: [
      { title: "Админ — Продукт | FIXHEN" },
      { name: "robots", content: "noindex, nofollow" },
    ],
  }),
  component: RouteComponent,
});

function RouteComponent() {
  const { id } = Route.useParams();
  return (
    <AdminLayout>
      <ProductEditor id={id} />
    </AdminLayout>
  );
}